import React from "react";

const IcClose = ({ color, onClick }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
        >
            <g id="close" >
                <path
                    id="Path 2"
                    d="M17.6564 17.6569L6.3427 6.34315"
                    stroke={color}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    id="Path 2_2"
                    d="M17.6573 6.34315L6.34359 17.6569"
                    stroke={color}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </g>
        </svg>
    );
};

IcClose.defaultProps = {
    color: "#fff",
};

export default IcClose;
